(function(){
  var root=document.getElementById('bmd-cap');
  if(!root||root.dataset.initialized==='1')return;
  root.dataset.initialized='1';

  var dialog=root.querySelector('[data-cap-dialog]');
  var mode=root.getAttribute('data-mode')||'entry';
  var context=root.getAttribute('data-context')||'browse';
  var delay=parseInt(root.getAttribute('data-delay'),10)||18000;
  var scrollThreshold=parseFloat(root.getAttribute('data-scroll'))||0;
  /* Oct 2 2026: on phones, articles get a bottom sheet instead of the full-screen
     modal (no backdrop, no scroll lock). Blog traffic is search traffic, and Google
     demotes intrusive mobile interstitials on the landing page. */
  var sheet=context==='education'&&window.matchMedia&&window.matchMedia('(max-width: 767px)').matches;
  if(sheet)root.classList.add('bmd-cap--sheet');
  var KEY='bmdCapV1';
  var shown=false;
  /* 2026-08-09 engagement deferral: when a trigger fires while the visitor is
     actively scrolling or moving, hold the popup until ~2s of quiet so it never
     interrupts mid-read. Exit intent stays immediate (the pause IS the signal). */
  var lastAct=Date.now();
  ['scroll','pointermove','keydown','touchstart'].forEach(function(ev){
    window.addEventListener(ev,function(){lastAct=Date.now();},{passive:true});
  });
  var patternKey='';
  var currentStep='pattern';
  var previousFocus=null;
  var previousOverflow='';
  var pageStarted=Date.now();
  var shownAt=0;
  var timer=null;
  var capturedEmail='';

  /* Jul 31 2026 — the pattern NAME is disclosed on the email step rather than held
     behind it. It is only the visitor's own answer reflected back, so charging an
     email for it read as a bait. The email now buys the substance: what the
     pattern means and the first thing to try. */
  var patterns={
    clear:{
      label:'Bloated and foggy',
      profile:'Clear pattern',
      emailTitle:'Sounds like the Clear pattern.',
      emailCopy:'Bloating and fog usually travel with sluggish digestion. Where should we send what that means and the first thing to try?',
      resultTitle:'Your likely starting pattern: Clear',
      resultCopy:'Bloating, brain fog and heavy afternoons often cluster together. Clear is the most relevant place to begin exploring.',
      url:'/products/mgb-clear',
      cta:'Explore MGB+ Clear'
    },
    cool:{
      label:'Hot or reactive after meals',
      profile:'Cool pattern',
      emailTitle:'Sounds like the Cool pattern.',
      emailCopy:'Post-meal heat, urgency and reactivity form a recognizable pattern. Where should we send what that means and the first thing to try?',
      resultTitle:'Your likely starting pattern: Cool',
      resultCopy:'Heat, urgency and loose-stool patterns often travel together. Cool is the most relevant place to begin exploring.',
      url:'/products/mgb-cool',
      cta:'Explore MGB+ Cool'
    },
    calm:{
      label:'Queasy or unsettled mornings',
      profile:'Calm pattern',
      emailTitle:'Sounds like the Calm pattern.',
      emailCopy:'Queasy mornings, appetite swings and a keyed-up gut tend to travel together. Where should we send what that means and the first thing to try?',
      resultTitle:'Your likely starting pattern: Calm',
      resultCopy:'Morning queasiness and an unsettled gut often cluster with stress-response signals. Calm is the most relevant place to begin exploring.',
      url:'/products/mgb-calm',
      cta:'Explore MGB+ Calm'
    },
    mixed:{
      label:'All of it, honestly',
      profile:'Mixed pattern',
      emailTitle:'Your answer crosses more than one pattern.',
      emailCopy:'Overlapping symptoms are common, and one question cannot separate them. Where should we send the fuller picture, plus the first thing to try?',
      resultTitle:'Your likely starting pattern: Mixed',
      resultCopy:'Your symptoms cross more than one pattern. The full two-minute quiz is the better next step before choosing a starting place.',
      url:'/pages/quiz',
      cta:'Take the full two-minute quiz'
    }
  };

  function store(){try{return JSON.parse(localStorage.getItem(KEY)||'{}')}catch(e){return {}}}
  function save(s){try{localStorage.setItem(KEY,JSON.stringify(s))}catch(e){}}
  function emailGiven(){try{return localStorage.getItem('bmd_email_given')==='1'}catch(e){return false}}
  function scrollDepth(){
    var doc=document.documentElement;
    var max=doc.scrollHeight-window.innerHeight;
    return max>0?Math.round((window.scrollY/max)*100):0;
  }
  function payload(extra){
    return Object.assign({
      mode:mode,
      context:context,
      page:location.pathname,
      pattern_key:patternKey||'',
      pattern:patterns[patternKey]?patterns[patternKey].profile:'',
      step:currentStep,
      page_elapsed_ms:Date.now()-pageStarted,
      popup_elapsed_ms:shownAt?Date.now()-shownAt:0,
      scroll_depth:scrollDepth()
    },extra||{});
  }
  function track(name,extra){
    var data=payload(extra);
    try{
      if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish){
        Shopify.analytics.publish(name.toLowerCase().replace(/\s+/g,'_'),data);
      }
    }catch(e){}
    try{
      window._learnq=window._learnq||[];
      window._learnq.push(['track',name,data]);
    }catch(e){}
  }
  function suppressed(){
    if(emailGiven())return true;
    var s=store();
    if(s.done)return true;
    if(s.dismissedAt){
      var days=(s.dismissCount||1)>=2?30:14;
      if(Date.now()-s.dismissedAt<days*864e5)return true;
    }
    try{if(sessionStorage.getItem('bmdCapSeen'))return true}catch(e){}
    if(/(^|;\s*)discount_code=/.test(document.cookie))return true;
    try{
      var cart=window.Alpine&&window.Alpine.store&&window.Alpine.store('bmdCart');
      if(cart&&(cart.isOpen||cart.itemCount>0))return true;
    }catch(e){}
    return false;
  }
  function focusable(){
    return Array.prototype.slice.call(dialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')).filter(function(el){return !el.hidden&&el.offsetParent!==null});
  }
  function focusStep(){
    var target;
    if(currentStep==='pattern')target=root.querySelector('[data-cap-pattern]');
    if(currentStep==='email')target=root.querySelector('[data-cap-form] input');
    if(currentStep==='done')target=root.querySelector('[data-cap-primary]');
    setTimeout(function(){(target||dialog).focus()},40);
  }
  function step(name){
    currentStep=name;
    var labels={pattern:'bmd-cap-title',email:'bmd-cap-email-title',done:'bmd-cap-result-title'};
    var descriptions={pattern:'bmd-cap-description',email:'bmd-cap-email-copy',done:'bmd-cap-result-copy'};
    dialog.setAttribute('aria-labelledby',labels[name]||'bmd-cap-title');
    dialog.setAttribute('aria-describedby',descriptions[name]||'bmd-cap-description');
    root.querySelectorAll('[data-cap-step]').forEach(function(el){
      if(el.getAttribute('data-cap-step')===name)el.removeAttribute('hidden');
      else el.setAttribute('hidden','');
    });
    focusStep();
  }
  function removeEntryListeners(){
    if(timer){clearTimeout(timer);timer=null}
    window.removeEventListener('scroll',onScroll);
    document.removeEventListener('mouseout',onExit);
  }
  function show(trigger){
    if(shown||suppressed())return;
    /* Articles carrying their own intent-matched inline offer (thiamine, CHS) already
       made the ask at ~40% depth; a popup at 50% would be a second interruption. */
    if(context==='education'&&document.getElementById('bmdInlineOfferBox'))return;
    if(trigger!=='exit_intent'){
      var idle=Date.now()-lastAct;
      if(idle<1900){ setTimeout(function(){show(trigger);}, 2000-idle); return; }
    }
    shown=true;
    shownAt=Date.now();
    removeEntryListeners();
    try{sessionStorage.setItem('bmdCapSeen','1')}catch(e){}
    previousFocus=document.activeElement;
    previousOverflow=document.documentElement.style.overflow;
    if(!sheet)document.documentElement.style.overflow='hidden';
    root.removeAttribute('hidden');
    document.addEventListener('keydown',onKey);
    focusStep();
    track('Capture Popup Shown',{presentation:sheet?'sheet':'modal',trigger:trigger||'unknown',configured_delay_ms:delay,configured_scroll_pct:Math.round(scrollThreshold*100)});
  }
  function hide(reason,countsAsDismissal){
    if(root.hidden)return;
    root.setAttribute('hidden','');
    document.documentElement.style.overflow=previousOverflow;
    document.removeEventListener('keydown',onKey);
    if(countsAsDismissal){
      var s=store();
      s.dismissedAt=Date.now();
      s.dismissCount=(s.dismissCount||0)+1;
      save(s);
    }
    track('Capture Popup Dismissed',{reason:reason||'unknown',dismissal_counted:!!countsAsDismissal});
    if(previousFocus&&typeof previousFocus.focus==='function')previousFocus.focus();
  }
  function onKey(e){
    if(e.key==='Escape'){
      e.preventDefault();
      hide('escape',true);
      return;
    }
    if(e.key!=='Tab')return;
    var items=focusable();
    if(!items.length){e.preventDefault();dialog.focus();return}
    var first=items[0],last=items[items.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}
  }
  function applyPattern(key){
    var p=patterns[key];
    if(!p)return;
    patternKey=key;
    root.querySelector('[data-cap-email-title]').textContent=p.emailTitle;
    root.querySelector('[data-cap-email-copy]').textContent=p.emailCopy;
    root.querySelector('[data-cap-result-title]').textContent=p.resultTitle;
    root.querySelector('[data-cap-result-copy]').textContent=p.resultCopy;
    var primary=root.querySelector('[data-cap-primary]');
    primary.href=p.url;
    primary.textContent=p.cta+' →';
    var quiz=root.querySelector('[data-cap-quiz]');
    if(key==='mixed')quiz.setAttribute('hidden','');
    else quiz.removeAttribute('hidden');
  }

  root.querySelectorAll('[data-cap-dismiss]').forEach(function(el){
    el.addEventListener('click',function(){hide(el.getAttribute('data-cap-dismiss')||'click',true)});
  });
  root.querySelectorAll('[data-cap-pattern]').forEach(function(el){
    el.addEventListener('click',function(){
      var key=el.getAttribute('data-cap-pattern')||'';
      applyPattern(key);
      track('Capture Pattern Selected',{selected_label:patterns[key]?patterns[key].label:''});
      step('email');
      track('Capture Email Step Viewed');
    });
  });
  var back=root.querySelector('[data-cap-back]');
  if(back)back.addEventListener('click',function(){
    track('Capture Pattern Changed');
    step('pattern');
  });

  /* Decline path. Rather than ending the session, hand the visitor to the quiz —
     the best-converting segment on the site, and a place where the email ask lands
     after the visitor has earned the result. Counts as a dismissal so the popup
     does not chase them, and leaves a breadcrumb for attribution. */
  root.querySelectorAll('[data-cap-quiz-instead]').forEach(function(el){
    el.addEventListener('click',function(){
      var from=el.getAttribute('data-cap-quiz-instead')||'pattern';
      try{
        localStorage.setItem('bmd_declined_to_quiz',JSON.stringify({
          at:Date.now(),
          from:from,
          pattern_key:patternKey||'',
          page:location.pathname
        }));
      }catch(e){}
      var s=store();
      s.dismissedAt=Date.now();
      s.dismissCount=(s.dismissCount||0)+1;
      save(s);
      track('Capture Declined To Quiz',{declined_from_step:from});
      document.documentElement.style.overflow=previousOverflow;
      window.location.href='/pages/quiz';
    });
  });

  var form=root.querySelector('[data-cap-form]');
  if(form)form.addEventListener('submit',function(e){
    e.preventDefault();
    var inp=form.querySelector('input');
    var btn=form.querySelector('button');
    var err=root.querySelector('[data-cap-err]');
    var em=(inp.value||'').trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(em)){
      err.textContent='Please enter a valid email address.';
      err.removeAttribute('hidden');
      inp.setAttribute('aria-invalid','true');
      inp.focus();
      track('Capture Form Validation Failed');
      return;
    }
    err.setAttribute('hidden','');
    inp.removeAttribute('aria-invalid');
    btn.disabled=true;
    btn.textContent='Sending…';
    var p=patterns[patternKey]||patterns.mixed;
    var props={
      popup_pattern:p.profile,
      popup_pattern_key:patternKey||'mixed',
      popup_pattern_answer:p.label,
      popup_mode:mode,
      popup_context:context,
      popup_page:location.pathname,
      popup_result_url:p.url
    };
    Promise.resolve(window.bmdSubscribeToList?window.bmdSubscribeToList(em,null,{source:'Popup',properties:props}):{ok:false,error:'unavailable'})
      .then(function(r){
        btn.disabled=false;
        btn.textContent='Send it to me';
        if(r&&r.ok){
          capturedEmail=em;
          var s=store();s.done=1;save(s);
          try{localStorage.setItem('bmd_email_given','1')}catch(e2){}
          track('Capture Popup Submitted',{result_url:p.url});
          try{
            if(window.bmdTrackEvent)window.bmdTrackEvent(em,'Submitted Capture Popup',props);
          }catch(e3){}
          step('done');
          track('Capture Result Viewed',{result_url:p.url});
        }else{
          err.textContent=(r&&r.error)||'Something went wrong. Please try again.';
          err.removeAttribute('hidden');
          track('Capture Submission Failed',{error:(r&&r.error)||'unknown'});
        }
      });
  });

  root.querySelectorAll('[data-cap-primary],[data-cap-quiz]').forEach(function(el){
    el.addEventListener('click',function(){
      track('Capture Result CTA Clicked',{destination:el.getAttribute('href'),cta_type:el.hasAttribute('data-cap-primary')?'primary':'quiz',email_captured:!!capturedEmail});
    });
  });

  function onScroll(){
    var doc=document.documentElement;
    var max=doc.scrollHeight-window.innerHeight;
    if(max>0&&window.scrollY/max>=scrollThreshold)show('scroll');
  }
  function onExit(e){
    if(e.clientY<=0&&!e.relatedTarget)show('exit_intent');
  }

  if(suppressed())return;
  if(mode==='entry'){
    timer=setTimeout(function(){show('timer')},delay);
    window.addEventListener('scroll',onScroll,{passive:true});
  }else if(window.matchMedia&&window.matchMedia('(pointer:fine)').matches){
    timer=setTimeout(function(){document.addEventListener('mouseout',onExit)},delay);
  }
})();
